exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#carouselContainer {\n  /* margin-top: 10%; */\n  width: 50%;\n  max-height: 50vh;\n  /* margin-left: 25%; */\n}\n.carouselImages {\n  padding-top: 5%;\n}\n", ""]);

// exports
